var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 147,
    height: 36,
    viewBox: "0 0 147 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_694_208)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0137 19.2578L31.291 29.9902L6.99609 21.541L3.57812 17.1113L26.4238 5.14844L27.9277 9.20898L25.002 10.9316L24.209 9.74219L12.082 16.25L24.0723 17.4941L12.0137 19.2578ZM28.1055 28.5547L25.7676 21.7188L29.377 3.58984L31.8379 5.57227L28.1055 28.5547ZM33.3691 9.67383L34.2715 5.16211L36.7324 7.14453L36.3086 9.74219L33.3691 9.67383ZM36.1035 11L33.2188 28.5547L30.8809 21.7188L33.0273 11.4238L36.1035 11ZM38.4277 20.7617L39.1113 22.6758L41.832 21.2949L43.4043 13.8438L42.6934 12.5039L40.3145 13.5293L38.4277 20.7617ZM35.2012 22.5801L37.5938 11.5059L43.377 9.85156L46.3027 11.998L44.416 23.4277L38.2637 25.6426L35.2012 22.5801ZM60.2656 18.4512L75.0586 11.7246L61.2773 9.00391L60.2656 18.4512ZM60.252 18.5469L59.3359 27.0781L54.8379 23.8516L58.4199 7.07617L62.1934 5.57227L79.8438 9.57812L80.418 13.0781L67.0605 17.7812L87.6914 28.0762L60.252 18.5469ZM85.7188 18.7188L81.8516 21.4609V22.8086L84.4883 23.2891L85.7188 18.7188ZM87.3594 23.8047L88.2852 23.9688L87.2891 24.1328L87.1133 25.0117L83.6797 26.2891L84.125 24.6602L79.7656 25.375L79.5898 19.6211L85.8594 18.2148L86.4805 15.9062L78.7344 11.9688L87.418 13.2578L89.0703 15.5195L87.3594 23.8047ZM92.8203 16.1641L91.1328 25.4102L88.9414 22.1875L91.2383 11.6055L93.3477 13.3047L93.0664 14.8516L96.8164 12.2031L98.5859 14.793L102.324 12.1445L104.211 14.9102L101.223 29.2305L99.125 24.8242L101.469 15.2148L98.4453 16.0703L96.1016 26.2891L94.1211 21.8828L95.9609 15.2734L92.8203 16.1641ZM106.824 21.3672L107.41 23.0078L109.742 21.8242L111.09 15.4375L110.48 14.2891L108.441 15.168L106.824 21.3672ZM104.059 22.9258L106.109 13.4336L111.066 12.0156L113.574 13.8555L111.957 23.6523L106.684 25.5508L104.059 22.9258ZM126.98 11.3477L117.242 16.0586L121.812 20.0195L121.566 23.2656L111.184 26.5352L118.895 21.3203L114.301 17.043L114.922 13.9844L126.98 11.3477Z",
    fill: "#FAFAFA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_694_208",
    x: 0.578125,
    y: 1.58984,
    width: 131.402,
    height: 34.4004,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.214583 0 0 0 0 0.819708 0 0 0 0 0.858333 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_694_208"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_694_208",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.54dcc419a1d3a711351b584ac85ac9a1.svg";
export { ForwardRef as ReactComponent };